export const buildImageUrl = (baseUrl, brand, imgName, isMobile, imgType) => {
  if (!baseUrl || !imgName) return ''; 
  const sufixMobile = isMobile ? '_mobile' : '';
  const url = `${baseUrl}/${brand}/${imgName}${sufixMobile}.${imgType}`;

  return encodeURI(url);
}